// Marque ciblée — détermine aussi l'URL de production.
export const SITE_THEME = 'vita'; // 'globalong' | 'vita'

// Environnement ciblé.
export const ENV = 'production'; // 'production' | 'recette' | 'local'

export const LANG = 'en'; // 'fr' | 'en'

// Modes de paiement proposés sur le dashboard de commande.
// Valeurs possibles :
//   'lcl'       — carte bancaire via la passerelle LCL (formulaire bancaire intégré)
//   'stripe'    — carte bancaire via Stripe (redirection vers Stripe Checkout)
//   'mobilepay' — MobilePay / Vipps (redirection vers la page hébergée Vipps ePayment)
//   'wire'      — virement bancaire
//   'check'     — chèque
// 'lcl', 'stripe' et 'mobilepay' sont indépendants : n'activer que la/les passerelle(s) utilisée(s) par la marque.
export const PAYMENT_METHODS = ['stripe', 'mobilepay', 'wire'];

// Recette et local sont des environnements partagés (non liés à la marque).
// La production a une URL dédiée par marque (chaque service est exposé sur
// un sous-domaine différent par marque).
// Pour ajouter un nouveau service (admin, intranet...), ajouter une entrée
// ici puis exporter `<NAME>_URI = resolveServiceUri('nom')` plus bas.
const SERVICE_URIS = {
    api: {
        production: {
            globalong: 'https://www.globalong.com',
            vita: 'https://www.vita-explorers.dk',
        },
        recette: 'https://www.vita-explorersdev.dk',
        local: 'https://www.globalongdev.com',
    },
    crm: {
        production: {
            globalong: 'https://crm.globalong.com',
            vita: 'https://crm.vita-explorers.dk',
        },
        recette: 'https://crm.vita-explorersdev.dk',
        local: 'https://crm.globalongdev.com',
    },
};

function resolveServiceUri(service) {
    const target = SERVICE_URIS[service][ENV];
    return typeof target === 'string' ? target : target[SITE_THEME];
}

export const API_URI = resolveServiceUri('api');
export const CRM_URI = resolveServiceUri('crm');

// Devise et acompte d'adhésion — alignés sur le .env Symfony
// (SITE_CURRENCY, SITE_CURRENCY_SYMBOL, MEMBERSHIP_FEE_CENTS).
// `locale` sert au formatage Intl.NumberFormat (symbole natif : € / kr).
const CURRENCY_CONFIG = {
    globalong: { code: 'EUR', symbol: '€',  locale: 'fr-FR', membershipFeeCents: 20000 },
    vita:      { code: 'DKK', symbol: 'kr', locale: 'da-DK', membershipFeeCents: 150000 },
};

export const CURRENCY = {
    code:   CURRENCY_CONFIG[SITE_THEME].code,
    symbol: CURRENCY_CONFIG[SITE_THEME].symbol,
    locale: CURRENCY_CONFIG[SITE_THEME].locale,
};

// En centimes — envoyé tel quel aux passerelles de paiement.
export const MEMBERSHIP_FEE_CENTS = CURRENCY_CONFIG[SITE_THEME].membershipFeeCents;